export default __webpack_public_path__ + "static/media/bigcommerce.277dc5ab.svg";